const lang = {
    'hero-caption-1': 'Subsidies from Industrial Development Bureau,',
    'hero-caption-2': 'Ministry of Economic Affairs',
    'travel-title': 'Total distance traveled',
    'travel-description-1': 'As far as the distance of circling',
    'travel-description-2': 'the Earth around the equator %{count} times.',
    'saving-title': 'CO<sub>2</sub> saved',
    'saving-description-1': 'As much as the amount of CO2',
    'saving-description-2': 'that %{count} trees absorb every year.',
    'unit-km': 'km',
    'unit-kg': 'kg',
    'summary': 'GoShare has put %{scooters} subsidized scooters into service by %{month} %{day}, %{year}. All statistics are calculated based on the total mileage of subsidized scooters.',
};

export default lang;
